export const isDashboard = () => {
  return window.location.pathname == "/u" || window.location.pathname.match(/^\/u\//) || window.location.pathname.match(/^\/account/) || window.location.pathname.match(/^\/admin/)
}
